// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"94852b34","377":"c7d7389d","778":"9c6ca5e2","787":"35e65106"}[chunkId] + ".chunk.js";
};